// extracted by mini-css-extract-plugin
export default {"container":"Contacts_container__Ovinl","column_list":"Contacts_column_list__1yokL","column_item":"Contacts_column_item__T4SD0"};